import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { TratamentoMadeira } from '../../types/aquisicao';
import { tratamentosMadeiraService } from '../../services';

const columns: ResourceColumn<TratamentoMadeira>[] = [
  { header: 'Lote', accessor: 'lote_info' },
  { header: 'Tipo', render: (item) => item.tipo_tratamento_info?.descricao ?? '—' },
  { header: 'Início', accessor: 'data_inicio' },
  { header: 'Fim', accessor: 'data_fim' },
  { header: 'Resultado', accessor: 'resultado' },
];

export const TratamentosMadeiraListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Tratamentos de madeira"
      description="Tratamentos aplicados aos lotes."
      columns={columns}
      service={tratamentosMadeiraService}
      createPath="/admin/aquisicao/tratamentos-madeira/novo"
      onEdit={(item) =>
        item.id &&
        navigate('/admin/aquisicao/tratamentos-madeira/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        item.id ? tratamentosMadeiraService.remove(item.id) : Promise.resolve()
      }
    />
  );
};
